import { BUS_TYPE_PAGE_API } from '../config/apiPoints';
import { fetchHelper } from '../../utils/fetchHelper';

export const prepareOperatorTypePageRequest = (params) => {
    return `${__ENV_CONFIG__.__PAGEROVER__}${BUS_TYPE_PAGE_API}?slug=${params.operatorName}-online-bus-booking-${params.bus_type}&op=${params.operatorName}&type=${params.bus_type}`;
}

export async function getOperatorTypePageData(params) {
    const url = prepareOperatorTypePageRequest(params);
    let data = {}
    try {
        data = await fetchHelper({
            name: 'route page',
            type: 'GET',
            url: url,
        });
    } catch (err) {
        data = {
            status: false,
            error: true
        }
    }
    return data;
}
